import PropTypes from "prop-types"

export const SECURITY_IDS = PropTypes.shape({
  modelProviderIds: PropTypes.arrayOf(PropTypes.string),
  swapTickers: PropTypes.arrayOf(PropTypes.string),
})
